import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { CartService } from 'src/app/services/cart.service';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-add-product-cart',
  templateUrl: './add-product-cart.component.html',
  styleUrls: ['./add-product-cart.component.scss']
})
export class AddProductCartComponent implements OnInit {

  isSending = false;
  isSaved = false;
  quantity = 1;

  constructor(
    public dialogRef: MatDialogRef<AddProductCartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected cartService: CartService,
    protected alertService: AlertService
    ) { }

  closeDialog(): void{
    this.dialogRef.close();
  }

  ngOnInit() {
    this.addInCart();
  }

  addInCart() {
    if (this.isSending) {
      return;
    }

    if (this.data.quantity) {
      this.quantity = this.data.quantity;
    }

    this.isSending = true;
    this.cartService.addItem(this.data.product.id, this.data.product.childs[0].id, this.quantity).toPromise().then(data => {
      if (!data.success) {
        this.alertService.showError('Error', data.error.message);
        this.closeDialog();
        return;
      }

      this.isSaved = true;
    });
  }
}
